export default {
  id: "1000",
  name: "Timeline First-Half",
  format: "1920x1080",
  options: {
    mode: "auto",
  },
  templates: [
    {
      templateId: "0001",
      template: "playerfacts",
    },
    {
      templateId: "0002",
      template: "playerstats",
    },
    {
      templateId: "0003",
      template: "teamfacts",
    },
    {
      templateId: "0004",
      template: "playercompare",
    },
    {
      templateId: "0005",
      template: "teamcompare",
    },
  ],
  total: 5,
  usedTemplates: [
    "playerfacts",
    "playerstats",
    "teamfacts",
    "teamcompare",
    "playercompare",
  ],
};
